export const arrayNotEmpty = <T>(v: T[] | null | undefined): v is T[] => v != null && v.length > 0;
